module.exports = __webpack_public_path__ + "media/images/tests/welcome-337ed8bc3e483c5bd0642ce9a5086f69.png";